function Footer() {
  return (
    <footer className="footer">
      <div className="content has-text-centered">
        <p>
          <a href="/politica-de-privacidad" className="footer-link">
            Política de Privacidad
          </a>{" "}
          |
          <a href="/terminos-de-servicio" className="footer-link">
            {" "}
            Términos de Servicio
          </a>{" "}
          |
          <a href="/contacto" className="footer-link">
            {" "}
            Contacto
          </a>
        </p>
        <p>Comunidad Victoria de Dios; Honduras, Centro America</p>

        <p>Todos los derechos reservados &copy; {new Date().getFullYear()}</p>
      </div>
    </footer>
  );
}

export default Footer;
